<template>
  <div class="mc-premium">
    <template v-if="carregando">
      <div class="mc-premium__loading">
        <b-spinner
          variant="primary"
          class="mc-premium__spinner"
        />
        <p class="mc-premium__loading-text">
          Carregando métricas...
        </p>
      </div>
    </template>

    <template v-else-if="metricas && metricas.campanha">
      <div class="mc-premium__shell mc-ref">
        <!-- 1. Header (layout referência) -->
        <header class="mc-ref-hero">
          <div
            class="mc-ref-hero__gradient"
            aria-hidden="true"
          />
          <div class="mc-ref-hero__top">
            <div class="mc-ref-hero__left">
              <div
                class="mc-ref-wa"
                aria-hidden="true"
              >
                <feather-icon
                  icon="MessageCircleIcon"
                  size="28"
                />
              </div>
              <div class="mc-ref-hero__titles">
                <h1 class="mc-ref-hero__title">
                  Campanha: {{ nomeCampanhaMetricas }}
                </h1>
                <span :class="classeBadgeStatusCampanha">{{ textoBadgeStatusCampanha }}</span>
              </div>
            </div>
            <div class="mc-ref-hero__actions">
              <b-button
                variant="outline-light"
                class="mc-ref-btn-detail mc-ref-btn-back-campanhas"
                @click="voltarAsCampanhas"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  size="18"
                  class="mc-ref-btn-back-campanhas__ico"
                />
                Voltar às campanhas
              </b-button>
            </div>
          </div>
          <div class="mc-ref-hero__meta">
            <div class="mc-ref-meta-cell">
              <span class="mc-ref-meta-label">Template</span>
              <span class="mc-ref-meta-value">{{ templateCampanha }}</span>
            </div>
            <div class="mc-ref-meta-cell">
              <span class="mc-ref-meta-label">Cupom</span>
              <span class="mc-ref-meta-value">{{ cupomCampanha }}</span>
            </div>
            <div class="mc-ref-meta-cell">
              <span class="mc-ref-meta-label">Audiência</span>
              <span class="mc-ref-meta-value">{{ audienciaHeaderNumero }}</span>
            </div>
            <div class="mc-ref-meta-cell">
              <span class="mc-ref-meta-label">Janela de atribuição</span>
              <span class="mc-ref-meta-value">{{ janelaAtribuicaoLabel }}</span>
            </div>
            <div class="mc-ref-meta-cell">
              <span class="mc-ref-meta-label">Executada em</span>
              <span class="mc-ref-meta-value">{{ executadaEmExibicao }}</span>
            </div>
            <div class="mc-ref-meta-cell">
              <span class="mc-ref-meta-label">Execuções</span>
              <span class="mc-ref-meta-value">{{ execucoesExibicao }}</span>
            </div>
          </div>
        </header>

        <div class="mc-premium__body mc-ref-body">
          <!-- 2. KPIs -->
          <section
            class="mc-ref-kpis"
            aria-label="Indicadores financeiros"
          >
            <article class="mc-ref-kpi mc-ref-kpi--g">
              <div class="mc-ref-kpi__icon mc-ref-kpi__icon--g">
                <feather-icon
                  icon="DollarSignIcon"
                  size="22"
                />
              </div>
              <div class="mc-ref-kpi__body">
                <span class="mc-ref-kpi__label">Faturamento Gerado</span>
                <span class="mc-ref-kpi__value">{{ formatarMoeda(metricas.roi.receita_total) }}</span>
                <span class="mc-ref-kpi__sub">{{ kpiSubFaturamento }}</span>
              </div>
            </article>
            <article class="mc-ref-kpi mc-ref-kpi--p">
              <div class="mc-ref-kpi__icon mc-ref-kpi__icon--p">
                <feather-icon
                  icon="TrendingUpIcon"
                  size="22"
                />
              </div>
              <div class="mc-ref-kpi__body">
                <span class="mc-ref-kpi__label">Lucro Gerado</span>
                <span class="mc-ref-kpi__value">{{ formatarMoeda(metricas.roi.lucro) }}</span>
                <span class="mc-ref-kpi__sub">{{ kpiSubLucro }}</span>
              </div>
            </article>
            <article class="mc-ref-kpi mc-ref-kpi--r">
              <div class="mc-ref-kpi__icon mc-ref-kpi__icon--r">
                <feather-icon
                  icon="CreditCardIcon"
                  size="22"
                />
              </div>
              <div class="mc-ref-kpi__body">
                <span class="mc-ref-kpi__label">Custo da Campanha</span>
                <span class="mc-ref-kpi__value">{{ formatarMoeda(metricas.roi.custo_estimado) }}</span>
                <span class="mc-ref-kpi__sub">{{ kpiSubCusto }}</span>
              </div>
            </article>
            <article class="mc-ref-kpi mc-ref-kpi--o">
              <div class="mc-ref-kpi__icon mc-ref-kpi__icon--o">
                <feather-icon
                  icon="RepeatIcon"
                  size="22"
                />
              </div>
              <div class="mc-ref-kpi__body">
                <span class="mc-ref-kpi__label">ROI</span>
                <span class="mc-ref-kpi__value">{{ formatarRoiVezes(metricas.roi) }}</span>
                <span class="mc-ref-kpi__sub">{{ kpiSubRoi }}</span>
              </div>
            </article>
            <article class="mc-ref-kpi mc-ref-kpi--b">
              <div class="mc-ref-kpi__icon mc-ref-kpi__icon--b">
                <feather-icon
                  icon="UsersIcon"
                  size="22"
                />
              </div>
              <div class="mc-ref-kpi__body">
                <span class="mc-ref-kpi__label">CAC da Campanha</span>
                <span class="mc-ref-kpi__value">{{ cacExibicao }}</span>
                <span class="mc-ref-kpi__sub">{{ kpiSubCac }}</span>
              </div>
            </article>
          </section>

          <p class="mc-ref-pedidos-link">
            <button
              type="button"
              class="mc-ref-pedidos-link__btn"
              @click="abrirModalPedidos"
            >
              Ver pedidos desta campanha
            </button>
          </p>

          <!-- 3. Primeira linha: 2 colunas -->
          <div class="mc-ref-row1">
            <section class="mc-ref-panel mc-ref-panel--wide">
              <h2 class="mc-ref-h2">
                Receita por Origem
              </h2>
              <div class="mc-ref-origin-layout">
                <ul class="mc-ref-origin-list">
                  <li>
                    <span class="mc-ref-origin-dot mc-ref-origin-dot--1" />
                    <span class="mc-ref-origin-name">Direta via clique</span>
                    <span class="mc-ref-origin-val">{{ formatarMoeda(metricas.conversoes.conversoes_diretas.valor_total) }}</span>
                  </li>
                  <li>
                    <span class="mc-ref-origin-dot mc-ref-origin-dot--2" />
                    <span class="mc-ref-origin-name">Influenciada (janela)</span>
                    <span class="mc-ref-origin-val">{{ formatarMoeda(metricas.conversoes.conversoes_janela_tempo.valor_total) }}</span>
                  </li>
                  <li>
                    <span class="mc-ref-origin-dot mc-ref-origin-dot--3" />
                    <span class="mc-ref-origin-name">uso de cupom - recebeu a campanha</span>
                    <span class="mc-ref-origin-val">{{ formatarMoeda(valorReceitaCupomImpactadosNum) }}</span>
                  </li>
                  <li>
                    <span class="mc-ref-origin-dot mc-ref-origin-dot--4" />
                    <span class="mc-ref-origin-name">uso de cupom - não recebeu a campanha</span>
                    <span class="mc-ref-origin-val">{{ formatarMoeda(valorReceitaCupomNaoImpactadosNum) }}</span>
                  </li>
                </ul>
                <div class="mc-ref-donut-wrap">
                  <div
                    class="mc-ref-donut"
                    :style="donutConicStyle"
                  >
                    <div class="mc-ref-donut__hole">
                      <span class="mc-ref-donut__total">{{ formatarMoeda(metricas.roi.receita_total) }}</span>
                      <span class="mc-ref-donut__cap">Receita total atribuída</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mc-ref-callout">
                <feather-icon
                  icon="ZapIcon"
                  size="18"
                  class="mc-ref-callout__ico"
                />
                <p class="mc-ref-callout__txt">
                  {{ textoCalloutReceitaOrigem }}
                </p>
              </div>
            </section>

            <section class="mc-ref-panel">
              <h2 class="mc-ref-h2">
                {{ tituloJanelaInfluenciada }}
              </h2>
              <div class="mc-ref-tempo-card">
                <span class="mc-ref-tempo-card__lbl">Tempo médio até compra</span>
                <span class="mc-ref-tempo-card__val">{{ tempoMedioCompraExibicao }}</span>
              </div>
              <p class="mc-ref-chart-title">
                Distribuição de compras por dia
              </p>
              <div class="mc-ref-bars">
                <div
                  v-for="(h, idx) in distribuicaoBarrasDiasInfluenciada"
                  :key="'bd-'+idx"
                  class="mc-ref-bars__col"
                >
                  <span class="mc-ref-bars__val">{{ h > 0 ? h : '' }}</span>
                  <div
                    class="mc-ref-bars__fill"
                    :style="{ height: maxDistribuicaoBarra ? (100 * h / maxDistribuicaoBarra) + '%' : '4%' }"
                  />
                  <span class="mc-ref-bars__lbl">Dia {{ idx }}</span>
                </div>
              </div>
              <div class="mc-ref-callout">
                <feather-icon
                  icon="ClockIcon"
                  size="18"
                  class="mc-ref-callout__ico"
                />
                <p class="mc-ref-callout__txt">
                  {{ textoCalloutComprasAte3Dias }}
                </p>
              </div>
            </section>
          </div>

          <!-- 4. Segunda linha: 3 blocos -->
          <div class="mc-ref-row2">
            <section class="mc-ref-panel mc-ref-panel--third">
              <div class="mc-ref-template-head">
                <h2 class="mc-ref-h2 mc-ref-template-head__title">
                  Performance do Template
                </h2>
                <div
                  v-if="usarValoresTemplateMeta"
                  class="mc-ref-template-tags"
                >
                  <span
                    v-if="templateNomeMeta"
                    class="mc-ref-template-tag"
                  >{{ templateNomeMeta }}</span>
                  <span
                    v-if="templateFonteMeta"
                    class="mc-ref-template-tag mc-ref-template-tag--muted"
                  >{{ templateFonteMeta }}</span>
                </div>
              </div>

              <b-alert
                v-if="templateMetricasErro"
                variant="warning"
                show
                class="mc-ref-template-alert py-2 px-3 mb-2 small"
              >
                <strong>Analytics do template:</strong> {{ templateMetricasErro }}.
                Exibindo métricas da campanha (bloco mensagens), se disponíveis.
              </b-alert>

              <div class="mc-ref-mesh">
                <div class="mc-ref-mesh__cell">
                  <span class="mc-ref-mesh__lbl">Enviados</span>
                  <span class="mc-ref-mesh__val">{{ formatarNumero(mensagensStats.enviadas) }}</span>
                </div>
                <div class="mc-ref-mesh__cell">
                  <span class="mc-ref-mesh__lbl">Entregues</span>
                  <span class="mc-ref-mesh__val">{{ formatarNumero(mensagensStats.entregues) }}</span>
                </div>
                <div class="mc-ref-mesh__cell">
                  <span class="mc-ref-mesh__lbl">Lidos</span>
                  <span class="mc-ref-mesh__val">{{ formatarNumero(mensagensStats.lidas) }}</span>
                </div>
                <div class="mc-ref-mesh__cell">
                  <span class="mc-ref-mesh__lbl">Taxa de leitura</span>
                  <span class="mc-ref-mesh__val">{{ taxaLeituraExibicao }}</span>
                </div>
                <div class="mc-ref-mesh__cell">
                  <span class="mc-ref-mesh__lbl">Cliques</span>
                  <span class="mc-ref-mesh__val">{{ mensagensCliquesExibicao }}</span>
                </div>
                <div class="mc-ref-mesh__cell">
                  <span class="mc-ref-mesh__lbl mc-ref-mesh__lbl--inline-help">
                    CTR
                    <span
                      v-b-tooltip.hover.top="'CTR (taxa de cliques): percentual de leituras da mensagem que geraram um clique no link. Fórmula: (cliques ÷ lidas) × 100.'"
                      class="mc-ref-mesh__help-q"
                      tabindex="0"
                    >?</span>
                  </span>
                  <span class="mc-ref-mesh__val">{{ mensagensCtrExibicao }}</span>
                </div>
              </div>
              <div class="mc-ref-callout mc-ref-callout--soft">
                <feather-icon
                  icon="EyeIcon"
                  size="18"
                  class="mc-ref-callout__ico"
                />
                <p class="mc-ref-callout__txt">
                  <template v-if="usarValoresTemplateMeta">
                    Métricas vinculadas ao <strong>nome do template</strong> na conta WhatsApp (Meta). Reutilizar o mesmo template em várias campanhas pode misturar os valores exibidos.
                  </template>
                  <template v-else>
                    Alta taxa de leitura indica que a mensagem gerou atenção da base.
                  </template>
                </p>
              </div>
            </section>

            <section class="mc-ref-panel mc-ref-panel--third mc-ref-panel--cupom-relative">
              <div :class="{ 'mc-ref-blur-target': !temCupomVinculado }">
                <h2 class="mc-ref-h2">
                  Uso do Cupom
                </h2>
                <ul class="mc-ref-plain">
                  <li>
                    <span class="mc-ref-plain__lbl">Receita com cupom (impactados)</span>
                    <span class="mc-ref-plain__val">{{ formatarMoeda(valorReceitaCupomImpactadosNum) }}</span>
                  </li>
                  <li>
                    <span class="mc-ref-plain__lbl">Receita com cupom (não impactados)</span>
                    <span class="mc-ref-plain__val">{{ formatarMoeda(valorReceitaCupomNaoImpactadosNum) }}</span>
                  </li>
                  <li>
                    <span class="mc-ref-plain__lbl">Receita total com cupom</span>
                    <span class="mc-ref-plain__val">{{ formatarMoeda(valorReceitaCupomNum) }}</span>
                  </li>
                  <li>
                    <span class="mc-ref-plain__lbl">Pedidos com cupom</span>
                    <span class="mc-ref-plain__val">{{ vendasCupomExibicao }}</span>
                  </li>
                </ul>
                <div class="mc-ref-callout mc-ref-callout--soft">
                  <feather-icon
                    icon="TagIcon"
                    size="18"
                    class="mc-ref-callout__ico"
                  />
                  <p class="mc-ref-callout__txt">
                    {{ textoCalloutUsoCupom }}
                  </p>
                </div>
              </div>
              <div
                v-if="!temCupomVinculado"
                class="mc-ref-cupom-overlay"
              >
                <p class="mc-ref-cupom-overlay__msg">
                  Não existe cupom vinculado a esta campanha.
                </p>
                <b-button
                  variant="primary"
                  size="sm"
                  class="mc-ref-cupom-overlay__btn"
                  @click="abrirModalVincularCupom"
                >
                  Vincular um cupom
                </b-button>
              </div>
            </section>

            <section class="mc-ref-panel mc-ref-panel--third">
              <h2 class="mc-ref-h2">
                Resumo Comercial
              </h2>
              <ul class="mc-ref-plain">
                <li>
                  <span class="mc-ref-plain__lbl">Clientes impactados</span>
                  <span class="mc-ref-plain__val">{{ formatarNumero(metricas.audiencia.total_leads || 0) }}</span>
                </li>
                <li>
                  <span class="mc-ref-plain__lbl">Clientes convertidos</span>
                  <span class="mc-ref-plain__val">{{ clientesConvertidosResumo }}</span>
                </li>
                <li>
                  <span class="mc-ref-plain__lbl">Pedidos realizados</span>
                  <span class="mc-ref-plain__val">{{ formatarNumero(metricas.conversoes.total) }}</span>
                </li>
                <li>
                  <span class="mc-ref-plain__lbl">Ticket médio</span>
                  <span class="mc-ref-plain__val">{{ formatarMoeda(metricas.conversoes.ticket_medio) }}</span>
                </li>
              </ul>
            </section>
          </div>

          <!-- 5. Rodapé insights -->
          <footer class="mc-ref-footer">
            <h2 class="mc-ref-h2 mc-ref-footer__title">
              Insights da Campanha
            </h2>
            <div class="mc-ref-footer__grid">
              <div class="mc-ref-foot-card">
                <feather-icon
                  icon="TrendingUpIcon"
                  size="22"
                  class="mc-ref-foot-card__ico"
                />
                <span class="mc-ref-foot-card__tit">Lucro gerado</span>
                <p class="mc-ref-foot-card__txt">
                  {{ formatarMoeda(metricas.roi.lucro) }} de lucro com ROI de {{ formatarRoiVezes(metricas.roi) }} sobre o investimento.
                </p>
              </div>
              <div class="mc-ref-foot-card">
                <feather-icon
                  icon="ZapIcon"
                  size="22"
                  class="mc-ref-foot-card__ico"
                />
                <span class="mc-ref-foot-card__tit">Influência das vendas</span>
                <p class="mc-ref-foot-card__txt">
                  {{ textoCalloutReceitaOrigem }}
                </p>
              </div>
              <div class="mc-ref-foot-card mc-ref-foot-card--cupom-relative">
                <div :class="{ 'mc-ref-blur-target': !temCupomVinculado }">
                  <feather-icon
                    icon="TagIcon"
                    size="22"
                    class="mc-ref-foot-card__ico"
                  />
                  <span class="mc-ref-foot-card__tit">Impacto do cupom</span>
                  <p class="mc-ref-foot-card__txt">
                    {{ receitaCupomFormatada }} em receita atribuída ao cupom, incluindo compras fora da audiência direta.
                  </p>
                </div>
                <div
                  v-if="!temCupomVinculado"
                  class="mc-ref-cupom-overlay mc-ref-cupom-overlay--footer"
                >
                  <p class="mc-ref-cupom-overlay__msg">
                    Não existe cupom vinculado a esta campanha.
                  </p>
                  <b-button
                    variant="primary"
                    size="sm"
                    class="mc-ref-cupom-overlay__btn"
                    @click="abrirModalVincularCupom"
                  >
                    Vincular um cupom
                  </b-button>
                </div>
              </div>
              <div class="mc-ref-foot-card">
                <feather-icon
                  icon="MailIcon"
                  size="22"
                  class="mc-ref-foot-card__ico"
                />
                <span class="mc-ref-foot-card__tit">Performance do template</span>
                <p class="mc-ref-foot-card__txt">
                  {{ textoInsightPerformanceTemplate }}
                </p>
              </div>
            </div>
          </footer>
        </div>
      </div>

      <!-- Modal de Pedidos -->
      <b-modal
        v-model="modalPedidosVisivel"
        title="Pedidos da Campanha"
        size="xl"
        centered
        scrollable
        @hidden="fecharModalPedidos"
      >
        <template v-if="carregandoPedidos">
          <div class="text-center py-5">
            <b-spinner variant="primary" />
            <p class="text-muted mt-3">
              Carregando pedidos...
            </p>
          </div>
        </template>

        <template v-else-if="pedidosCampanha && pedidosCampanha.length">
          <div class="mb-3">
            <b-alert
              variant="info"
              show
              class="mb-3"
            >
              <div class="d-flex align-items-center">
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                  class="mr-2"
                />
                <div>
                  <strong>{{ pedidosCampanha.length }}</strong> pedido(s) encontrado(s) nesta campanha
                </div>
              </div>
            </b-alert>
          </div>

          <!-- Container com scroll para a tabela -->
          <div class="pedidos-container">
            <!-- Tabela de Pedidos -->
            <b-table
              :items="pedidosCampanha"
              :fields="camposPedidos"
              :per-page="perPage"
              :current-page="currentPage"
              striped
              hover
              responsive
              show-empty
              empty-text="Nenhum pedido encontrado"
              class="pedidos-table"
              :tbody-tr-class="'pedido-row'"
            >
              <!-- Data -->
              <template #cell(created_at)="data">
                <small>{{ formatarDataCompleta(data.item.created_at) }}</small>
              </template>

              <!-- Cliente -->
              <template #cell(customer_name)="data">
                <div>
                  <strong>{{ data.item.customer_name || 'N/A' }}</strong>
                  <br>
                  <small class="text-muted">{{ data.item.customer_phone || 'N/A' }}</small>
                </div>
              </template>

              <!-- Valor -->
              <template #cell(order_value)="data">
                <strong class="text-success">{{ formatarMoeda(data.item.order_value) }}</strong>
              </template>

              <!-- Método de Conversão -->
              <template #cell(conversion_method)="data">
                <b-badge
                  :variant="data.item.conversion_method === 'direct' ? 'success' : 'info'"
                  class="text-capitalize"
                >
                  <feather-icon
                    :icon="data.item.conversion_method === 'direct' ? 'ZapIcon' : 'ClockIcon'"
                    size="12"
                    class="mr-1"
                  />
                  {{ data.item.conversion_method === 'direct' ? 'Direta' : 'Janela' }}
                </b-badge>
              </template>

              <!-- Tempo até Conversão -->
              <template #cell(time_to_conversion)="data">
                <small class="text-muted">
                  {{ formatarTempoConversao(data.item.time_to_conversion) }}
                </small>
              </template>
            </b-table>
          </div>

          <!-- Paginação -->
          <div
            v-if="pedidosCampanha.length > perPage"
            class="mt-3 d-flex justify-content-between align-items-center flex-wrap"
          >
            <div class="mb-2">
              <small class="text-muted">
                Mostrando {{ (currentPage - 1) * perPage + 1 }} a {{ Math.min(currentPage * perPage, pedidosCampanha.length) }} de {{ pedidosCampanha.length }} pedidos
              </small>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="pedidosCampanha.length"
              :per-page="perPage"
              size="sm"
              class="mb-0"
              align="right"
            />
          </div>
        </template>

        <template v-else>
          <div class="text-center py-5">
            <feather-icon
              icon="PackageIcon"
              size="48"
              class="text-muted mb-3"
            />
            <p class="text-muted">
              Nenhum pedido encontrado para esta campanha.
            </p>
          </div>
        </template>

        <template #modal-footer>
          <div class="d-flex justify-content-between w-100">
            <b-button
              variant="success"
              :disabled="!pedidosCampanha || pedidosCampanha.length === 0"
              @click="baixarCSV"
            >
              <feather-icon
                icon="DownloadIcon"
                size="14"
                class="mr-1"
              />
              Baixar CSV
            </b-button>
            <b-button
              variant="secondary"
              @click="fecharModalPedidos"
            >
              Fechar
            </b-button>
          </div>
        </template>
      </b-modal>

      <b-modal
        v-model="modalCupomVisivel"
        title="Vincular cupom à campanha"
        centered
        :no-close-on-backdrop="salvandoCupomVinculo"
        :no-close-on-esc="salvandoCupomVinculo"
        @hidden="onModalCupomHidden"
      >
        <b-form-group
          label-for="metricas-input-coupon-code"
          label="Nome do cupom"
          description="Código do cupom utilizado nesta campanha."
        >
          <b-form-input
            id="metricas-input-coupon-code"
            v-model="cupomVinculoInput"
            placeholder="Informe o código do cupom"
            :disabled="salvandoCupomVinculo"
            maxlength="255"
            @keyup.enter.prevent="salvarCupomCampanha"
          />
        </b-form-group>
        <b-alert
          v-if="erroCupomVinculo"
          variant="danger"
          show
          class="mb-0"
        >
          {{ erroCupomVinculo }}
        </b-alert>
        <template #modal-footer>
          <b-button
            variant="secondary"
            :disabled="salvandoCupomVinculo"
            @click="fecharModalCupom"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            :disabled="salvandoCupomVinculo"
            @click="salvarCupomCampanha"
          >
            <b-spinner
              v-if="salvandoCupomVinculo"
              small
              class="mr-50"
            />
            Salvar
          </b-button>
        </template>
      </b-modal>
    </template>

    <template v-else>
      <div class="text-center py-5">
        <feather-icon
          icon="AlertCircleIcon"
          size="48"
          class="text-muted mb-3"
        />
        <p class="text-muted">
          Não foi possível carregar as métricas.
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import {
  BModal,
  BTable,
  BPagination,
  BFormSelect,
  BFormGroup,
  BFormInput,
  BButton,
  BSpinner,
  BCard,
  BAlert,
  BBadge,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import {
  buscarMetricasCampanha, buscarPedidosCampanha, buscarAudiencias, listarCampanhas, atualizarCupomCampanha,
} from '@/functions/basics/campaign-oficial'

export default {
  name: 'MetricasCampanhaOficialView',
  components: {
    BModal,
    BTable,
    BPagination,
    BFormSelect,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
    BCard,
    BAlert,
    BBadge,
    FeatherIcon,
  },

  props: {
    campanhaId: {
      type: Number,
      default: null,
    },
    storeUuid: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      metricas: null,
      carregando: false,
      modalPedidosVisivel: false,
      pedidosCampanha: [],
      carregandoPedidos: false,
      currentPage: 1,
      perPage: 10,
      audiencias: [],
      campanhaCompleta: null,
      perPageOptions: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ],
      camposPedidos: [
        { key: 'created_at', label: 'Data', sortable: true },
        { key: 'order_id', label: 'Pedido', sortable: true },
        { key: 'customer_name', label: 'Cliente', sortable: true },
        { key: 'order_value', label: 'Valor', sortable: true },
        { key: 'conversion_method', label: 'Método', sortable: true },
        { key: 'time_to_conversion', label: 'Tempo até Conversão', sortable: true },
      ],
      modalCupomVisivel: false,
      cupomVinculoInput: '',
      salvandoCupomVinculo: false,
      erroCupomVinculo: '',
    }
  },

  computed: {
    nomeCampanhaMetricas() {
      if (this.metricas && this.metricas.campanha && this.metricas.campanha.name) {
        return this.metricas.campanha.name
      }
      if (this.campanhaCompleta && this.campanhaCompleta.name) {
        return this.campanhaCompleta.name
      }
      return 'Campanha'
    },
    templateCampanha() {
      if (this.campanhaCompleta && this.campanhaCompleta.template_name) {
        return this.campanhaCompleta.template_name
      }
      if (this.metricas && this.metricas.campanha && this.metricas.campanha.template_name) {
        return this.metricas.campanha.template_name
      }
      return '—'
    },
    /** Cupom agregado no root da resposta (`metricas.cupom`). */
    cupomRaiz() {
      const c = this.metricas?.cupom
      return c && typeof c === 'object' && !Array.isArray(c) ? c : null
    },
    usarMetricasCupomRaiz() {
      const c = this.cupomRaiz
      if (!c) return false
      if (c.configurado === false) return false
      const hasNums = b => {
        if (!b || typeof b !== 'object') return false
        return (b.valor_total != null && b.valor_total !== '')
          || (b.pedidos != null && b.pedidos !== '')
          || (b.leads_unicos != null && b.leads_unicos !== '')
      }
      return hasNums(c.total) || hasNums(c.receberam_campanha) || hasNums(c.nao_receberam_campanha)
    },

    cupomCampanha() {
      const api = this.cupomRaiz
      if (api && api.codigo != null && String(api.codigo).trim() !== '') {
        return String(api.codigo).trim()
      }
      const c = this.campanhaCompleta || {}
      const codigo = c.coupon_code || c.coupon || c.discount_code || c.promo_code
      if (codigo) return codigo
      const conv = this.metricas && this.metricas.conversoes
      if (conv && conv.cupom_codigo) return conv.cupom_codigo
      return '—'
    },

    temCupomVinculado() {
      const c = this.cupomRaiz
      if (c && c.configurado === false) return false
      const label = this.cupomCampanha
      if (label == null || label === '—') return false
      return String(label).trim() !== ''
    },

    /** Bloco `template` retornado pelo endpoint (analytics Meta por nome de template). */
    templateMetricasObj() {
      const t = this.metricas?.template
      return t && typeof t === 'object' && !Array.isArray(t) ? t : null
    },
    templateMetricasErro() {
      const e = this.templateMetricasObj?.erro
      return e != null && String(e).trim() !== '' ? String(e).trim() : null
    },
    /** Usa números do template quando o payload é válido (sem erro). */
    usarValoresTemplateMeta() {
      if (!this.templateMetricasObj || this.templateMetricasErro) return false
      const t = this.templateMetricasObj
      const has = v => v != null && v !== '' && !Number.isNaN(Number(v))
      return has(t.enviados) || has(t.entregue) || has(t.lidos) || has(t.cliques)
    },
    templateObservacaoMeta() {
      const o = this.templateMetricasObj?.observacao
      return o != null && String(o).trim() !== '' ? String(o).trim() : ''
    },
    templateFonteMeta() {
      const f = this.templateMetricasObj?.fonte
      return f != null && String(f).trim() !== '' ? String(f).trim() : ''
    },
    templateNomeMeta() {
      const n = this.templateMetricasObj?.nome
      return n != null && String(n).trim() !== '' ? String(n).trim() : ''
    },

    mensagensStats() {
      const m = (this.metricas && this.metricas.mensagens) || {}
      const t = this.templateMetricasObj
      if (this.usarValoresTemplateMeta && t) {
        return {
          enviadas: parseInt(t.enviados, 10) || 0,
          entregues: parseInt(t.entregue, 10) || 0,
          lidas: parseInt(t.lidos, 10) || 0,
        }
      }
      return {
        enviadas: parseInt(m.enviadas, 10) || parseInt(m.enviadas_total, 10) || 0,
        entregues: parseInt(m.entregues, 10) || 0,
        lidas: parseInt(m.lidas, 10) || 0,
      }
    },
    mensagensCliquesExibicao() {
      const t = this.templateMetricasObj
      if (this.usarValoresTemplateMeta && t) {
        const c = t.cliques
        if (c != null && c !== '') return this.formatarNumero(Number(c))
      }
      const m = (this.metricas && this.metricas.mensagens) || {}
      const c = m.cliques ?? m.clicks ?? m.total_cliques ?? m.link_clicks
      if (c != null && c !== '') return this.formatarNumero(Number(c))
      return '—'
    },
    mensagensCtrExibicao() {
      const t = this.templateMetricasObj
      if (this.usarValoresTemplateMeta && t) {
        const raw = t.ctr_percentual ?? t.ctr
        if (raw != null && raw !== '') {
          const n = Number(String(raw).replace('%', '').replace(',', '.'))
          if (Number.isFinite(n)) return `${n.toFixed(2)}%`
        }
        const cli = Number(t.cliques) || 0
        const lid = Number(t.lidos) || 0
        if (lid > 0) return `${((cli / lid) * 100).toFixed(2)}%`
      }
      const m = (this.metricas && this.metricas.mensagens) || {}
      if (m.ctr != null && m.ctr !== '') return `${Number(String(m.ctr).replace(',', '.')).toFixed(2)}%`
      if (m.taxa_clique != null && m.taxa_clique !== '') return `${Number(String(m.taxa_clique).replace(',', '.')).toFixed(2)}%`
      const cli = Number(m.cliques ?? m.clicks ?? 0)
      const lid = this.mensagensStats.lidas
      if (lid > 0 && cli >= 0) return `${((cli / lid) * 100).toFixed(2)}%`
      return '—'
    },
    taxaLeituraExibicao() {
      const t = this.templateMetricasObj
      if (this.usarValoresTemplateMeta && t) {
        const raw = t.taxa_leitura_percentual ?? t.taxa_leitura
        if (raw != null && raw !== '') {
          const n = Number(String(raw).replace('%', '').replace(',', '.'))
          if (Number.isFinite(n)) return `${n.toFixed(2)}%`
        }
        const ent = parseInt(t.entregue, 10) || 0
        const lid = parseInt(t.lidos, 10) || 0
        if (ent > 0) return `${((lid / ent) * 100).toFixed(2)}%`
      }
      const m = (this.metricas && this.metricas.mensagens) || {}
      if (m.taxa_leitura != null && m.taxa_leitura !== '') {
        return `${Number(String(m.taxa_leitura).replace(',', '.')).toFixed(1)}%`
      }
      const ent = this.mensagensStats.entregues
      const lid = this.mensagensStats.lidas
      if (ent > 0) {
        return `${((lid / ent) * 100).toFixed(1)}%`
      }
      return '—'
    },
    textoInsightPerformanceTemplate() {
      if (this.usarValoresTemplateMeta) {
        return `${this.taxaLeituraExibicao} de leitura e CTR ${this.mensagensCtrExibicao} (analytics agregados por template na Meta, o mesmo template em outras campanhas pode alterar estes números).`
      }
      return `${this.taxaLeituraExibicao} de leitura com ${this.formatarNumero(this.mensagensStats.entregues)} entregas confirmadas no WhatsApp.`
    },
    cacExibicao() {
      const roi = this.metricas && this.metricas.roi
      const conv = this.metricas && this.metricas.conversoes
      if (roi && roi.cac != null && roi.cac !== '') {
        const api = typeof roi.cac === 'string' ? parseFloat(roi.cac) : Number(roi.cac)
        if (Number.isFinite(api)) {
          return this.formatarMoeda(api)
        }
      }
      const custo = roi != null ? Number(roi.custo_estimado) : NaN
      const compradores = conv != null ? Number(conv.total) : NaN
      if (Number.isFinite(custo) && Number.isFinite(compradores) && compradores > 0 && custo >= 0) {
        return this.formatarMoeda(custo / compradores)
      }
      return '—'
    },
    cupomMetricasObj() {
      const conv = this.metricas && this.metricas.conversoes
      return (conv && conv.cupom) || {}
    },
    receitaCupomFormatada() {
      if (this.usarMetricasCupomRaiz) {
        return this.formatarMoeda(this.valorReceitaCupomNum)
      }
      const conv = this.metricas && this.metricas.conversoes
      if (!conv) return '—'
      const cup = conv.cupom || {}
      const raw = conv.receita_cupom != null && conv.receita_cupom !== ''
        ? conv.receita_cupom
        : (cup.receita_total != null ? cup.receita_total : cup.valor_total)
      if (raw != null && raw !== '') {
        return this.formatarMoeda(raw)
      }
      return '—'
    },
    vendasCupomExibicao() {
      const cr = this.cupomRaiz
      if (this.usarMetricasCupomRaiz && cr?.total?.pedidos != null && cr.total.pedidos !== '') {
        return this.formatarNumero(cr.total.pedidos)
      }
      const conv = this.metricas && this.metricas.conversoes
      const cup = this.cupomMetricasObj
      const raw = (conv && conv.vendas_cupom) || cup.total_vendas || cup.vendas
      if (raw != null && raw !== '') {
        return this.formatarNumero(raw)
      }
      return '—'
    },
    cupomImpactadosExibicao() {
      const cr = this.cupomRaiz
      if (this.usarMetricasCupomRaiz && cr?.receberam_campanha?.leads_unicos != null && cr.receberam_campanha.leads_unicos !== '') {
        return this.formatarNumero(cr.receberam_campanha.leads_unicos)
      }
      const cup = this.cupomMetricasObj
      const raw = cup.clientes_impactados != null ? cup.clientes_impactados : cup.impactados
      if (raw != null && raw !== '') {
        return this.formatarNumero(raw)
      }
      return '—'
    },
    cupomNaoImpactadosExibicao() {
      const cr = this.cupomRaiz
      if (this.usarMetricasCupomRaiz && cr?.nao_receberam_campanha?.leads_unicos != null && cr.nao_receberam_campanha.leads_unicos !== '') {
        return this.formatarNumero(cr.nao_receberam_campanha.leads_unicos)
      }
      const cup = this.cupomMetricasObj
      const raw = cup.clientes_nao_impactados != null ? cup.clientes_nao_impactados : cup.nao_impactados
      if (raw != null && raw !== '') {
        return this.formatarNumero(raw)
      }
      return '—'
    },
    /** Timestamp ms da execução do envio (mesma fonte que "Executada em" no topo). */
    dataExecucaoCampanhaMs() {
      const c = this.campanhaCompleta || {}
      const iso = c.last_sent_at || c.last_run_sent_at || c.executed_at || c.send_date
        || this.metricas?.campanha?.last_sent_at || this.metricas?.campanha?.send_date
      if (!iso) return null
      const t = new Date(iso).getTime()
      return Number.isFinite(t) ? t : null
    },
    tempoMedioCompraExibicao() {
      const pedidosArr = Array.isArray(this.pedidosCampanha) ? this.pedidosCampanha : []
      const execMs = this.dataExecucaoCampanhaMs
      if (pedidosArr.length > 0 && execMs != null) {
        const mins = pedidosArr
          .map(p => {
            if (!p || !p.created_at) return null
            const t = new Date(p.created_at).getTime()
            if (!Number.isFinite(t)) return null
            return (t - execMs) / 60000
          })
          .filter(m => m != null && Number.isFinite(m) && m >= 0)
        if (mins.length > 0) {
          const avg = mins.reduce((a, b) => a + b, 0) / mins.length
          return avg < 1
            ? `${Math.round(avg * 60)} s`
            : this.formatarTempoConversao(avg)
        }
      }
      const conv = this.metricas && this.metricas.conversoes
      if (!conv) return '—'
      const min = conv.tempo_medio_ate_compra_minutos != null
        ? conv.tempo_medio_ate_compra_minutos
        : conv.tempo_medio_conversao_minutos
      if (min != null && min !== '' && !Number.isNaN(Number(min))) {
        return this.formatarTempoConversao(Number(min))
      }
      return '—'
    },

    /** Valores numéricos brutos para barras de origem (sem formatação) */
    valorReceitaDiretaNum() {
      const v = this.metricas?.conversoes?.conversoes_diretas?.valor_total
      const n = Number(v)
      return Number.isFinite(n) && n >= 0 ? n : 0
    },
    valorReceitaInfluenciadaNum() {
      const v = this.metricas?.conversoes?.conversoes_janela_tempo?.valor_total
      const n = Number(v)
      return Number.isFinite(n) && n >= 0 ? n : 0
    },
    valorReceitaCupomNum() {
      const cr = this.cupomRaiz
      if (this.usarMetricasCupomRaiz && cr?.total?.valor_total != null && cr.total.valor_total !== '') {
        const n = Number(cr.total.valor_total)
        if (Number.isFinite(n) && n >= 0) return n
      }
      if (this.usarMetricasCupomRaiz && cr) {
        const a = Number(cr.receberam_campanha?.valor_total) || 0
        const b = Number(cr.nao_receberam_campanha?.valor_total) || 0
        if (a > 0 || b > 0) return a + b
      }
      const conv = this.metricas?.conversoes
      if (!conv) return 0
      const cup = conv.cupom || {}
      const raw = conv.receita_cupom != null && conv.receita_cupom !== ''
        ? conv.receita_cupom
        : (cup.receita_total != null ? cup.receita_total : cup.valor_total)
      const n = Number(raw)
      return Number.isFinite(n) && n >= 0 ? n : 0
    },
    somaOrigemVendasNum() {
      return this.valorReceitaDiretaNum + this.valorReceitaInfluenciadaNum + this.valorReceitaCupomNum
    },
    pctBarraDireta() {
      const s = this.somaOrigemVendasNum
      if (s <= 0) return 0
      return Math.min(100, (this.valorReceitaDiretaNum / s) * 100)
    },
    pctBarraInfluenciada() {
      const s = this.somaOrigemVendasNum
      if (s <= 0) return 0
      return Math.min(100, (this.valorReceitaInfluenciadaNum / s) * 100)
    },
    pctBarraCupom() {
      const s = this.somaOrigemVendasNum
      if (s <= 0) return 0
      return Math.min(100, (this.valorReceitaCupomNum / s) * 100)
    },

    /** % da receita total que não veio de conversão direta (para callout) */
    pctReceitaSemCliqueDireto() {
      const total = Number(this.metricas?.roi?.receita_total)
      if (!Number.isFinite(total) || total <= 0) return null
      const direta = this.valorReceitaDiretaNum
      const pct = Math.round(((total - direta) / total) * 100)
      return Math.min(100, Math.max(0, pct))
    },
    textoCalloutOrigem() {
      const p = this.pctReceitaSemCliqueDireto
      if (p == null) {
        return 'Parte relevante da receita pode ter sido influenciada sem clique direto no link enviado.'
      }
      return `${p}% da receita veio de clientes que não clicaram no link enviado.`
    },

    receitaPorClienteImpactadoCupom() {
      const cr = this.cupomRaiz
      if (this.usarMetricasCupomRaiz && cr?.receberam_campanha) {
        const v = Number(cr.receberam_campanha.valor_total)
        const leads = Number(cr.receberam_campanha.leads_unicos)
        if (Number.isFinite(leads) && leads > 0 && Number.isFinite(v)) {
          return this.formatarMoeda(v / leads)
        }
      }
      const cup = this.cupomMetricasObj
      const impactados = Number(cup.clientes_impactados ?? cup.impactados)
      const conv = this.metricas?.conversoes
      const raw = conv?.receita_cupom != null && conv.receita_cupom !== ''
        ? conv.receita_cupom
        : (cup.receita_total != null ? cup.receita_total : cup.valor_total)
      const receita = Number(raw)
      if (!Number.isFinite(impactados) || impactados <= 0 || !Number.isFinite(receita)) {
        return '—'
      }
      return this.formatarMoeda(receita / impactados)
    },

    textoBadgeStatusCampanha() {
      const s = this.campanhaCompleta && this.campanhaCompleta.last_run_status
      if (s === 'completed') return 'Finalizada'
      if (s === 'scheduled') return 'Agendada'
      if (s === 'dispatching') return 'Enviando'
      if (s === 'ready' || s === 'building') return 'Em preparação'
      if (s === 'cancelled') return 'Cancelada'
      if (s === 'paused') return 'Pausada'
      if (s === 'failed') return 'Falhou'
      if (s === 'inactive') return 'Inativa'
      return 'Ativa'
    },
    classeBadgeStatusCampanha() {
      const s = this.campanhaCompleta && this.campanhaCompleta.last_run_status
      if (s === 'completed') return 'mc-ref-badge mc-ref-badge--done'
      if (s === 'scheduled') return 'mc-ref-badge mc-ref-badge--sched'
      if (s === 'dispatching' || s === 'building') return 'mc-ref-badge mc-ref-badge--run'
      if (s === 'cancelled' || s === 'failed' || s === 'inactive') return 'mc-ref-badge mc-ref-badge--off'
      return 'mc-ref-badge mc-ref-badge--default'
    },

    audienciaHeaderNumero() {
      const n = Number(this.metricas?.audiencia?.total_leads)
      if (Number.isFinite(n)) return this.formatarNumero(n)
      return this.getNomeAudiencia(this.getAudienceId())
    },
    janelaAtribuicaoDiasTitulo() {
      const h = Number(this.metricas?.campanha?.attribution_window_hours)
      if (!Number.isFinite(h) || h <= 0) return '7'
      const dias = Math.max(1, Math.round(h / 24))
      return String(dias)
    },
    tituloJanelaInfluenciada() {
      const d = Number(this.janelaAtribuicaoDiasTitulo)
      const un = d === 1 ? 'Dia' : 'Dias'
      return `Vendas Influenciadas na Janela de ${this.janelaAtribuicaoDiasTitulo} ${un}`
    },
    janelaAtribuicaoLabel() {
      const h = this.metricas?.campanha?.attribution_window_hours
      if (h == null) return '—'
      if (Number(h) >= 24 && Number(h) % 24 === 0) return `${Number(h) / 24} dias`
      return `${h}h`
    },
    executadaEmExibicao() {
      const c = this.campanhaCompleta || {}
      const d = c.last_sent_at || c.last_run_sent_at || c.executed_at || c.send_date
      if (d) return this.formatarData(d)
      const m = this.metricas?.campanha?.last_sent_at || this.metricas?.campanha?.send_date
      return m ? this.formatarData(m) : '—'
    },
    execucoesExibicao() {
      const n = this.campanhaCompleta?.total_runs ?? this.metricas?.campanha?.total_runs
      if (n != null && n !== '') return this.formatarNumero(n)
      return '—'
    },

    valorReceitaCupomImpactadosNum() {
      const cr = this.cupomRaiz
      if (this.usarMetricasCupomRaiz && cr?.receberam_campanha?.valor_total != null && cr.receberam_campanha.valor_total !== '') {
        const r = Number(cr.receberam_campanha.valor_total)
        if (Number.isFinite(r) && r >= 0) return r
      }
      const cup = this.cupomMetricasObj
      const r = Number(cup.receita_impactados ?? cup.receita_clientes_impactados ?? cup.valor_impactados)
      if (Number.isFinite(r) && r >= 0) return r
      const total = this.valorReceitaCupomNum
      const imp = Number(cup.clientes_impactados ?? cup.impactados) || 0
      const nao = Number(cup.clientes_nao_impactados ?? cup.nao_impactados) || 0
      const den = imp + nao
      if (den > 0 && total > 0) return (total * imp) / den
      return total > 0 ? total * 0.5 : 0
    },
    valorReceitaCupomNaoImpactadosNum() {
      const cr = this.cupomRaiz
      if (this.usarMetricasCupomRaiz && cr?.nao_receberam_campanha?.valor_total != null && cr.nao_receberam_campanha.valor_total !== '') {
        const r = Number(cr.nao_receberam_campanha.valor_total)
        if (Number.isFinite(r) && r >= 0) return r
      }
      const cup = this.cupomMetricasObj
      const r = Number(cup.receita_nao_impactados ?? cup.receita_clientes_nao_impactados ?? cup.valor_nao_impactados)
      if (Number.isFinite(r) && r >= 0) return r
      const total = this.valorReceitaCupomNum
      const vImp = this.valorReceitaCupomImpactadosNum
      const rest = total - vImp
      return rest > 0 ? rest : 0
    },

    somaReceitaOrigemDonut() {
      return this.valorReceitaDiretaNum + this.valorReceitaInfluenciadaNum
        + this.valorReceitaCupomImpactadosNum + this.valorReceitaCupomNaoImpactadosNum
    },
    donutConicStyle() {
      const t = this.somaReceitaOrigemDonut
      if (!t || t <= 0) {
        return { background: 'conic-gradient(from -90deg, #e8e4f3 0deg 360deg)' }
      }
      const p = v => (v / t) * 100
      const a = p(this.valorReceitaDiretaNum)
      const b = p(this.valorReceitaInfluenciadaNum)
      const c = p(this.valorReceitaCupomImpactadosNum)
      const d = p(this.valorReceitaCupomNaoImpactadosNum)
      const g = `conic-gradient(from -90deg,
        #28c76f 0% ${a}%,
        #6a2fb1 ${a}% ${a + b}%,
        #e11d8a ${a + b}% ${a + b + c}%,
        #ff8a80 ${a + b + c}% 100%)`
      return { background: g }
    },

    textoCalloutReceitaOrigem() {
      const total = Number(this.metricas?.roi?.receita_total)
      const direta = this.valorReceitaDiretaNum
      if (!Number.isFinite(total) || total <= 0) {
        return 'Parte da receita tende a ser influenciada após o recebimento da campanha, mesmo sem clique direto.'
      }
      const pct = Math.round(((total - direta) / total) * 100)
      return `${Math.min(100, Math.max(0, pct))}% da receita foi influenciada após o recebimento da campanha, mesmo sem clique direto.`
    },

    distribuicaoBarrasDiasInfluenciada() {
      const janelaDias = Number(this.janelaAtribuicaoDiasTitulo) || 7
      const len = janelaDias + 1
      const pedidosArr = Array.isArray(this.pedidosCampanha) ? this.pedidosCampanha : []
      const execMs = this.dataExecucaoCampanhaMs
      if (pedidosArr.length > 0 && execMs != null) {
        const buckets = Array(len).fill(0)
        const MS_DIA = 86400000
        for (const p of pedidosArr) {
          if (!p || !p.created_at) continue
          const orderMs = new Date(p.created_at).getTime()
          if (!Number.isFinite(orderMs)) continue
          const diffMs = orderMs - execMs
          if (diffMs < 0) continue
          const dia = Math.floor(diffMs / MS_DIA)
          if (dia > janelaDias) continue
          buckets[dia] += 1
        }
        return buckets
      }
      const conv = this.metricas?.conversoes
      const raw = conv?.distribuicao_influenciadas_por_dia || conv?.influenciadas_por_dia
        || conv?.compras_por_dia || conv?.vendas_por_dia_janela
      const pad = arr => {
        const out = [...arr]
        while (out.length < len) out.push(0)
        return out.slice(0, len)
      }
      if (Array.isArray(raw) && raw.length) {
        const nums = raw.map(x => Number(x.pedidos ?? x.total ?? x.valor ?? x) || 0)
        return pad(nums)
      }
      if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
        return pad(
          Array.from({ length: len }, (_, i) => Number(raw[i] ?? raw[`dia_${i}`] ?? raw[`day_${i}`]) || 0),
        )
      }
      const total = Number(conv?.conversoes_janela_tempo?.total) || 0
      if (total <= 0) return Array(len).fill(0)
      const wBase = [0.35, 0.25, 0.12, 0.1, 0.08, 0.05, 0.03, 0.02]
      while (wBase.length < len) wBase.push(1 / len)
      const wAdj = wBase.slice(0, len)
      const sumW = wAdj.reduce((a, b) => a + b, 0)
      return wAdj.map(x => Math.max(0, Math.round((total * x) / sumW)))
    },
    maxDistribuicaoBarra() {
      const arr = this.distribuicaoBarrasDiasInfluenciada
      const m = Math.max(...arr, 1)
      return m
    },
    textoCalloutComprasAte3Dias() {
      const arr = this.distribuicaoBarrasDiasInfluenciada
      const sum = arr.reduce((x, y) => x + y, 0)
      if (sum <= 0) {
        return 'Distribuição de compras influenciadas ao longo dos dias após o envio.'
      }
      const ate3 = (arr[0] || 0) + (arr[1] || 0) + (arr[2] || 0) + (arr[3] || 0)
      const pct = Math.round((ate3 / sum) * 100)
      return `${pct}% das compras influenciadas ocorreram até 3 dias após o recebimento da campanha.`
    },

    pctReceitaCupomNaoImpactados() {
      const total = this.valorReceitaCupomNum
      const nao = this.valorReceitaCupomNaoImpactadosNum
      if (!total || total <= 0) return null
      return Math.round((nao / total) * 100)
    },
    textoCalloutUsoCupom() {
      const p = this.pctReceitaCupomNaoImpactados
      if (p == null) {
        return 'Parte da receita com cupom pode vir de clientes fora da audiência impactada.'
      }
      return `${p}% da receita com cupom veio de clientes fora da audiência impactada.`
    },

    clientesConvertidosResumo() {
      const conv = this.metricas?.conversoes
      if (!conv) return '—'
      const direct = Number(conv.leads_unicos_convertidos ?? conv.clientes_convertidos)
      if (Number.isFinite(direct) && direct >= 0) return this.formatarNumero(direct)
      const a = Number(conv.conversoes_diretas?.leads_unicos) || 0
      const b = Number(conv.conversoes_janela_tempo?.leads_unicos) || 0
      return this.formatarNumero(a + b)
    },
    kpiSubFaturamento() {
      const n = this.metricas?.conversoes?.total
      return n != null ? `${this.formatarNumero(n)} pedidos` : '—'
    },
    kpiSubLucro() {
      return 'Resultado após custos'
    },
    kpiSubCusto() {
      return 'Investimento estimado'
    },
    kpiSubRoi() {
      return 'Retorno sobre custo'
    },
    kpiSubCac() {
      const leads = this.metricas?.audiencia?.total_leads
      return leads != null ? `${this.formatarNumero(leads)} leads na base` : '—'
    },
  },

  watch: {
    campanhaId() {
      this.bootstrapDados()
    },
    storeUuid() {
      this.bootstrapDados()
    },
  },

  mounted() {
    this.bootstrapDados()
  },

  methods: {
    voltarAsCampanhas() {
      this.$router.push({
        name: 'campaign-oficiais',
        params: { uuid: this.storeUuid },
      })
    },

    abrirModalVincularCupom() {
      this.erroCupomVinculo = ''
      this.cupomVinculoInput = ''
      this.modalCupomVisivel = true
    },

    fecharModalCupom() {
      if (this.salvandoCupomVinculo) return
      this.modalCupomVisivel = false
    },

    onModalCupomHidden() {
      this.cupomVinculoInput = ''
      this.erroCupomVinculo = ''
    },

    extrairMsgErroApi(error) {
      const d = error.response?.data
      let msg = (typeof d === 'string' && d)
        || (d != null && (d.message || d.error || d.msg || d.detail))
        || error.message
        || 'Não foi possível vincular o cupom.'
      if (typeof msg !== 'string') {
        msg = typeof msg === 'object' ? JSON.stringify(msg) : String(msg)
      }
      return msg
    },

    async salvarCupomCampanha() {
      const code = String(this.cupomVinculoInput || '').trim()
      if (!code) {
        this.erroCupomVinculo = 'Informe o código do cupom.'
        return
      }
      if (!this.storeUuid || this.campanhaId == null) {
        this.erroCupomVinculo = 'Dados da campanha indisponíveis.'
        return
      }
      this.salvandoCupomVinculo = true
      this.erroCupomVinculo = ''
      try {
        await atualizarCupomCampanha(this.storeUuid, this.campanhaId, code)
        window.location.reload()
      } catch (e) {
        const msg = this.extrairMsgErroApi(e)
        console.error('Erro ao vincular cupom:', e)
        this.erroCupomVinculo = msg
        this.$bvToast.toast(msg, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.salvandoCupomVinculo = false
      }
    },

    bootstrapDados() {
      if (!this.storeUuid || this.campanhaId == null) return
      this.pedidosCampanha = []
      this.carregarAudiencias()
      this.carregarCampanhaCompleta()
      this.carregarMetricas()
      this.carregarPedidosCampanha({ silent: true })
    },

    async carregarAudiencias() {
      try {
        const audiencias = await buscarAudiencias(this.storeUuid)
        this.audiencias = audiencias || []
      } catch (error) {
        console.error('Erro ao carregar audiências:', error)
        this.audiencias = []
      }
    },

    async carregarCampanhaCompleta() {
      try {
        const campanhas = await listarCampanhas(this.storeUuid)
        this.campanhaCompleta = campanhas.find(c => c.id === this.campanhaId) || null
      } catch (error) {
        console.error('Erro ao carregar campanha completa:', error)
        this.campanhaCompleta = null
      }
    },

    async carregarMetricas() {
      this.carregando = true
      try {
        const response = await buscarMetricasCampanha(this.storeUuid, this.campanhaId)
        this.metricas = response.data
      } catch (error) {
        console.error('Erro ao carregar métricas:', error)
        this.$bvToast.toast('Erro ao carregar métricas da campanha', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.carregando = false
      }
    },

    /**
     * Lista de pedidos do endpoint de orders (array `data`). Usada no modal e no gráfico da janela.
     */
    async carregarPedidosCampanha({ silent = false } = {}) {
      try {
        const response = await buscarPedidosCampanha(this.storeUuid, this.campanhaId)
        const raw = response && response.data
        this.pedidosCampanha = Array.isArray(raw) ? raw : []
      } catch (error) {
        console.error('Erro ao carregar pedidos da campanha:', error)
        this.pedidosCampanha = []
        if (!silent) {
          this.$bvToast.toast('Erro ao carregar pedidos da campanha', {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          })
        }
      }
    },

    getNomeAudiencia(audienceId) {
      if (!audienceId) return 'N/A'

      const audiencia = this.audiencias.find(a => a.value === audienceId)
      return audiencia ? audiencia.text : `Audiência #${audienceId}`
    },

    getAudienceId() {
      // Tenta obter o audience_id da campanha completa primeiro
      if (this.campanhaCompleta && this.campanhaCompleta.audience_id) {
        return this.campanhaCompleta.audience_id
      }
      // Se não tiver, tenta obter das métricas
      if (this.metricas && this.metricas.campanha && this.metricas.campanha.audience_id) {
        return this.metricas.campanha.audience_id
      }
      return null
    },

    async abrirModalPedidos() {
      this.modalPedidosVisivel = true
      if (this.pedidosCampanha.length > 0) {
        return
      }
      this.carregandoPedidos = true
      try {
        await this.carregarPedidosCampanha({ silent: false })
      } finally {
        this.carregandoPedidos = false
      }
    },

    fecharModalPedidos() {
      this.modalPedidosVisivel = false
      this.currentPage = 1
      this.perPage = 10
    },

    baixarCSV() {
      if (!this.pedidosCampanha || this.pedidosCampanha.length === 0) {
        this.$bvToast.toast('Nenhum pedido para exportar', {
          title: 'Aviso',
          variant: 'warning',
          solid: true,
        })
        return
      }

      try {
        // Definir cabeçalhos do CSV
        const headers = [
          'Data',
          'ID do Pedido',
          'Cliente',
          'Telefone',
          'Valor',
          'Método de Conversão',
          'Tempo até Conversão (min)',
        ]

        // Criar linhas do CSV
        const rows = this.pedidosCampanha.map(pedido => [
          this.formatarDataCompleta(pedido.created_at),
          pedido.order_id || 'N/A',
          pedido.customer_name || 'N/A',
          pedido.customer_phone || 'N/A',
          pedido.order_value || '0',
          pedido.conversion_method === 'direct' ? 'Direta' : 'Janela',
          pedido.time_to_conversion || '0',
        ])

        // Combinar cabeçalhos e linhas
        const csvContent = [
          headers.join(','),
          ...rows.map(row => row.map(cell => `"${cell}"`).join(',')),
        ].join('\n')

        // Adicionar BOM para suporte a caracteres especiais no Excel
        const BOM = '\uFEFF'
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })

        // Criar link de download
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)

        // Nome do arquivo com timestamp
        const nomeCampanha = this.metricas?.campanha?.name || 'campanha'
        const timestamp = new Date().toISOString().split('T')[0]
        const nomeArquivo = `pedidos_${nomeCampanha}_${timestamp}.csv`

        link.setAttribute('href', url)
        link.setAttribute('download', nomeArquivo)
        link.style.visibility = 'hidden'

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // Liberar URL
        URL.revokeObjectURL(url)

        this.$bvToast.toast('CSV baixado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error('Erro ao gerar CSV:', error)
        this.$bvToast.toast('Erro ao gerar arquivo CSV', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },

    formatarNumero(valor) {
      if (valor === null || valor === undefined) return '0'
      return new Intl.NumberFormat('pt-BR').format(valor)
    },

    formatarMoeda(valor) {
      if (valor === null || valor === undefined) return 'R$ 0,00'
      const numero = typeof valor === 'string' ? parseFloat(valor) : valor
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(numero)
    },

    /** ROI em vezes (x): receita/custo = (lucro/custo) + 1, fórmula correta de retorno sobre investimento. */
    formatarRoiVezes(roi) {
      if (!roi) return '—'
      const custo = Number(roi.custo_estimado)
      const receita = Number(roi.receita_total)
      if (custo > 0 && Number.isFinite(receita)) {
        const mult = receita / custo
        return `${mult.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 })}x`
      }
      const p = roi.roi_percentual
      const pct = typeof p === 'string' ? parseFloat(p) : p
      if (pct !== null && pct !== undefined && Number.isFinite(pct)) {
        // roi_percentual = (lucro/custo)*100; ROI(x) = receita/custo = (lucro/custo) + 1
        const mult = pct / 100 + 1
        return `${mult.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 })}x`
      }
      return '—'
    },

    formatarData(data) {
      if (!data) return 'N/A'
      return new Date(data).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },

    formatarDataCompleta(data) {
      if (!data) return 'N/A'
      return new Date(data).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },

    formatarTempoConversao(minutos) {
      if (!minutos || minutos === 0) return 'Imediato'

      const horas = Math.floor(minutos / 60)
      const mins = Math.floor(minutos % 60)

      if (horas > 0) {
        return `${horas}h ${mins}min`
      }

      return `${mins}min`
    },
  },
}
</script>

<style scoped>
/* Variáveis — painel premium campanha WhatsApp */
.mc-premium {
  --mc-purple: #6a2fb1;
  --mc-purple-deep: #4a148c;
  --mc-magenta: #c026d3;
  --mc-coral: #ff6b6b;
  --mc-lilac-bg: #f4f2ff;
  --mc-lilac-soft: #f8f7ff;
  --mc-pink-tint: #fdf5f8;
  --mc-page-bg: #f0f2fb;
  --mc-text: #1e1b2e;
  --mc-text-muted: #6b6a7c;
  --mc-border-soft: rgba(106, 47, 177, 0.1);
  --mc-shadow: 0 8px 32px rgba(74, 20, 140, 0.08);
  --mc-shadow-hover: 0 12px 40px rgba(74, 20, 140, 0.12);
  --mc-radius-lg: 28px;
  --mc-radius-md: 20px;
  --mc-radius-sm: 14px;
  width: 100%;
  max-width: none;
  margin-left: 0;
  margin-right: 0;
  font-family: inherit;
}

.mc-premium__loading {
  text-align: center;
  padding: 4rem 1.5rem;
  background: var(--mc-lilac-soft);
  border-radius: var(--mc-radius-md);
}

.mc-premium__spinner {
  width: 2.75rem !important;
  height: 2.75rem !important;
  color: var(--mc-purple) !important;
}

.mc-premium__loading-text {
  margin: 1rem 0 0;
  color: var(--mc-text-muted);
  font-size: 0.95rem;
}

.mc-premium__shell {
  background: var(--mc-page-bg);
  border-radius: var(--mc-radius-lg);
  overflow: hidden;
  box-shadow: var(--mc-shadow);
}

/* Layout referência — painel WhatsApp */
.mc-ref-body.mc-premium__body,
.mc-premium__body.mc-ref-body {
  padding: 1.75rem 1.75rem 2.25rem;
  background: linear-gradient(180deg, var(--mc-lilac-bg) 0%, var(--mc-page-bg) 50%);
}

.mc-ref-hero {
  position: relative;
  border-radius: var(--mc-radius-lg) var(--mc-radius-lg) 0 0;
  overflow: hidden;
  background: linear-gradient(
    118deg,
    var(--mc-purple-deep) 0%,
    var(--mc-purple) 22%,
    #b91cac 48%,
    #e11d8a 72%,
    var(--mc-coral) 100%
  );
}

.mc-ref-hero__gradient {
  position: absolute;
  inset: -35%;
  background:
    radial-gradient(ellipse 55% 45% at 8% 5%, rgba(255, 255, 255, 0.2) 0%, transparent 45%),
    radial-gradient(circle at 95% 85%, rgba(255, 180, 170, 0.45) 0%, transparent 40%);
  pointer-events: none;
}

.mc-ref-hero__top {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  padding: 2rem 2.25rem 1.25rem;
}

.mc-ref-hero__left {
  display: flex;
  align-items: center;
  gap: 1.1rem;
  flex: 1;
  min-width: 0;
}

.mc-ref-wa {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #25d366;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}

.mc-ref-hero__titles {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  min-width: 0;
}

.mc-ref-hero__title {
  margin: 0;
  font-size: clamp(1.35rem, 2.8vw, 1.85rem);
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.mc-ref-badge {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.35);
}

.mc-ref-badge--done {
  background: rgba(46, 213, 115, 0.25);
  color: #c8ffd4;
}

.mc-ref-badge--sched {
  background: rgba(255, 193, 7, 0.2);
  color: #fff3cd;
}

.mc-ref-badge--run {
  background: rgba(0, 207, 232, 0.22);
  color: #e0fbff;
}

.mc-ref-badge--off {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.85);
}

.mc-ref-badge--default {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.mc-ref-hero__actions {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.mc-ref-btn-detail {
  border-radius: 14px !important;
  font-weight: 600 !important;
  padding: 0.65rem 1.35rem !important;
  border: 2px solid rgba(255, 255, 255, 0.85) !important;
  color: #fff !important;
  background: transparent !important;
}

.mc-ref-btn-detail:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  color: #fff !important;
}

.mc-ref-btn-back-campanhas {
  display: inline-flex !important;
  align-items: center;
  gap: 0.4rem;
}

.mc-ref-btn-back-campanhas__ico {
  flex-shrink: 0;
}

.mc-ref-panel.mc-ref-panel--cupom-relative,
.mc-ref-foot-card.mc-ref-foot-card--cupom-relative {
  position: relative;
  overflow: hidden;
}

.mc-ref-foot-card.mc-ref-foot-card--cupom-relative {
  min-height: 10.5rem;
}

.mc-ref-blur-target {
  filter: blur(5px);
  pointer-events: none;
  user-select: none;
  opacity: 0.52;
}

.mc-ref-cupom-overlay {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1rem 1.25rem;
  gap: 0.65rem;
  background: rgba(255, 255, 255, 0.78);
}

.mc-ref-cupom-overlay--footer {
  border-radius: 16px;
}

.mc-ref-cupom-overlay__msg {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--mc-text);
  max-width: 15rem;
  line-height: 1.35;
}

.mc-ref-hero__meta {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 1rem 1.25rem;
  padding: 1.2rem 2rem 1.75rem;
  margin: 0 1.5rem 1.5rem;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: var(--mc-radius-md);
}

.mc-ref-meta-label {
  display: block;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 0.3rem;
}

.mc-ref-meta-value {
  font-size: 0.88rem;
  font-weight: 600;
  color: #fff;
  line-height: 1.35;
  word-break: break-word;
}

/* KPIs referência */
.mc-ref-kpis {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.mc-ref-kpi {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 1.2rem 1rem;
  border-radius: 18px;
  border: 1px solid transparent;
  background: #fff;
  box-shadow: 0 4px 22px rgba(106, 47, 177, 0.07);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.mc-ref-kpi:hover {
  transform: translateY(-3px);
  box-shadow: var(--mc-shadow-hover);
}

.mc-ref-kpi--g { border-color: rgba(40, 199, 111, 0.2); background: linear-gradient(145deg, #fff 0%, rgba(40, 199, 111, 0.06) 100%); }
.mc-ref-kpi--p { border-color: rgba(106, 47, 177, 0.2); background: linear-gradient(145deg, #fff 0%, rgba(106, 47, 177, 0.06) 100%); }
.mc-ref-kpi--r { border-color: rgba(255, 107, 107, 0.22); background: linear-gradient(145deg, #fff 0%, rgba(255, 107, 107, 0.06) 100%); }
.mc-ref-kpi--o { border-color: rgba(255, 152, 0, 0.22); background: linear-gradient(145deg, #fff 0%, rgba(255, 152, 0, 0.07) 100%); }
.mc-ref-kpi--b { border-color: rgba(0, 186, 209, 0.2); background: linear-gradient(145deg, #fff 0%, rgba(0, 186, 209, 0.06) 100%); }

.mc-ref-kpi__icon {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mc-ref-kpi__icon--g { background: rgba(40, 199, 111, 0.15); color: #1f9d5c; }
.mc-ref-kpi__icon--p { background: rgba(106, 47, 177, 0.14); color: var(--mc-purple); }
.mc-ref-kpi__icon--r { background: rgba(255, 107, 107, 0.15); color: #e55555; }
.mc-ref-kpi__icon--o { background: rgba(255, 152, 0, 0.16); color: #e65100; }
.mc-ref-kpi__icon--b { background: rgba(0, 186, 209, 0.14); color: #00838f; }

.mc-ref-kpi__body { min-width: 0; }
.mc-ref-kpi__label {
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--mc-text-muted);
  margin-bottom: 0.35rem;
}
.mc-ref-kpi__value {
  display: block;
  font-size: clamp(1.05rem, 2.1vw, 1.4rem);
  font-weight: 800;
  color: var(--mc-text);
  letter-spacing: -0.025em;
  line-height: 1.15;
}
.mc-ref-kpi__sub {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.75rem;
  color: var(--mc-text-muted);
  font-weight: 500;
}

.mc-ref-pedidos-link {
  text-align: right;
  margin: 0 0 1.5rem;
}
.mc-ref-pedidos-link__btn {
  background: none;
  border: none;
  padding: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--mc-purple);
  text-decoration: underline;
  cursor: pointer;
}
.mc-ref-pedidos-link__btn:hover { color: var(--mc-purple-deep); }

.mc-ref-h2 {
  margin: 0 0 1.1rem;
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--mc-text);
  letter-spacing: -0.02em;
}

.mc-ref-panel {
  background: #fff;
  border-radius: var(--mc-radius-md);
  padding: 1.5rem 1.5rem 1.35rem;
  border: 1px solid var(--mc-border-soft);
  box-shadow: var(--mc-shadow);
}

.mc-ref-row1 {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(0, 1fr);
  gap: 1.35rem;
  margin-bottom: 1.35rem;
}

.mc-ref-panel--wide { min-height: 100%; }

.mc-ref-origin-layout {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 1.25rem;
}

.mc-ref-origin-list {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;
  min-width: 200px;
}

.mc-ref-origin-list li {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid rgba(106, 47, 177, 0.07);
}

.mc-ref-origin-list li:last-child { border-bottom: none; }

.mc-ref-origin-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.mc-ref-origin-dot--1 { background: #28c76f; }
.mc-ref-origin-dot--2 { background: var(--mc-purple); }
.mc-ref-origin-dot--3 { background: #e11d8a; }
.mc-ref-origin-dot--4 { background: #ff8a80; }

.mc-ref-origin-name {
  flex: 1;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--mc-text);
}
.mc-ref-origin-val {
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--mc-text);
  letter-spacing: -0.02em;
}

.mc-ref-donut-wrap {
  flex-shrink: 0;
  width: 200px;
  max-width: 100%;
  margin-left: auto;
}

.mc-ref-donut {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 50%;
  box-shadow: 0 8px 32px rgba(106, 47, 177, 0.12);
}

.mc-ref-donut__hole {
  position: absolute;
  inset: 18%;
  border-radius: 50%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0.5rem;
  box-shadow: inset 0 2px 12px rgba(0, 0, 0, 0.04);
}

.mc-ref-donut__total {
  font-size: clamp(0.8rem, 2.5vw, 0.95rem);
  font-weight: 800;
  color: var(--mc-text);
  line-height: 1.2;
}
.mc-ref-donut__cap {
  font-size: 0.62rem;
  font-weight: 600;
  color: var(--mc-text-muted);
  margin-top: 0.25rem;
  line-height: 1.25;
  max-width: 7rem;
}

.mc-ref-callout {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem 1.1rem;
  border-radius: 16px;
  background: linear-gradient(95deg, rgba(106, 47, 177, 0.08) 0%, rgba(255, 107, 107, 0.08) 100%);
  border: 1px solid rgba(106, 47, 177, 0.1);
}
.mc-ref-callout--soft {
  background: linear-gradient(95deg, rgba(186, 104, 200, 0.1) 0%, rgba(255, 183, 197, 0.12) 100%);
}
.mc-ref-callout__ico {
  flex-shrink: 0;
  color: var(--mc-purple);
  margin-top: 2px;
}
.mc-ref-callout__txt {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.5;
  color: #4a3a6b;
  font-weight: 500;
}

.mc-ref-tempo-card {
  padding: 1rem 1.15rem;
  border-radius: 16px;
  background: var(--mc-lilac-soft);
  border: 1px solid var(--mc-border-soft);
  margin-bottom: 1rem;
}
.mc-ref-tempo-card__lbl {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--mc-text-muted);
  margin-bottom: 0.35rem;
}
.mc-ref-tempo-card__val {
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--mc-purple);
  letter-spacing: -0.02em;
}

.mc-ref-chart-title {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--mc-text-muted);
  margin: 0 0 0.65rem;
}

.mc-ref-bars {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.35rem;
  height: 140px;
  padding: 0 0.25rem;
  margin-bottom: 1rem;
}

.mc-ref-bars__col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  min-width: 0;
}

.mc-ref-bars__fill {
  width: 100%;
  max-width: 36px;
  margin: 0 auto auto;
  border-radius: 8px 8px 4px 4px;
  background: linear-gradient(180deg, var(--mc-magenta) 0%, var(--mc-purple) 100%);
  min-height: 4px;
  transition: height 0.4s ease;
}

.mc-ref-bars__val {
  font-size: 0.6rem;
  font-weight: 700;
  color: var(--mc-text-muted);
  margin-bottom: 0.2rem;
  text-align: center;
  min-height: 1em;
  line-height: 1;
}

.mc-ref-bars__lbl {
  font-size: 0.62rem;
  font-weight: 600;
  color: var(--mc-text-muted);
  margin-top: 0.4rem;
  text-align: center;
}

.mc-ref-row2 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem;
  margin-bottom: 1.5rem;
}

.mc-ref-panel--third {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.mc-ref-template-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.5rem 1rem;
  margin-bottom: 0.75rem;
}

.mc-ref-template-head__title {
  margin-bottom: 0 !important;
}

.mc-ref-template-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.mc-ref-template-tag {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.25rem 0.55rem;
  border-radius: 8px;
  background: rgba(106, 47, 177, 0.12);
  color: var(--mc-purple);
}

.mc-ref-template-tag--muted {
  background: rgba(106, 47, 177, 0.06);
  color: var(--mc-text-muted);
  font-weight: 600;
}

.mc-ref-template-alert {
  border-radius: 12px !important;
  border: 1px solid rgba(106, 47, 177, 0.12) !important;
}

.mc-ref-mesh {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
  margin-bottom: 1rem;
}

.mc-ref-mesh__cell {
  text-align: center;
  padding: 0.75rem 0.4rem;
  border-radius: 14px;
  background: var(--mc-lilac-soft);
  border: 1px solid rgba(106, 47, 177, 0.08);
}

.mc-ref-mesh__lbl {
  display: block;
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--mc-text-muted);
  margin-bottom: 0.3rem;
}

.mc-ref-mesh__lbl--inline-help {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  width: 100%;
}

.mc-ref-mesh__help-q {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  font-size: 0.65rem;
  font-weight: 800;
  line-height: 1;
  color: var(--mc-purple);
  background: rgba(106, 47, 177, 0.12);
  cursor: help;
}
.mc-ref-mesh__val {
  font-size: 1rem;
  font-weight: 800;
  color: var(--mc-text);
}

.mc-ref-plain {
  list-style: none;
  margin: 0 0 1rem;
  padding: 0;
  flex: 1;
}

.mc-ref-plain li {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.75rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid rgba(106, 47, 177, 0.07);
}

.mc-ref-plain li:last-child { border-bottom: none; }

.mc-ref-plain__lbl {
  font-size: 0.8rem;
  color: var(--mc-text-muted);
  font-weight: 500;
}
.mc-ref-plain__val {
  font-size: 0.92rem;
  font-weight: 800;
  color: var(--mc-text);
  text-align: right;
}

.mc-ref-footer {
  margin-top: 0.25rem;
}
.mc-ref-footer__title {
  margin-bottom: 1rem !important;
}
.mc-ref-footer__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.mc-ref-foot-card {
  padding: 1.15rem 1.1rem;
  border-radius: 18px;
  background: linear-gradient(160deg, #fff 0%, var(--mc-lilac-soft) 100%);
  border: 1px solid var(--mc-border-soft);
  box-shadow: 0 4px 20px rgba(106, 47, 177, 0.06);
}

.mc-ref-foot-card__ico {
  color: var(--mc-purple);
  margin-bottom: 0.5rem;
}
.mc-ref-foot-card__tit {
  display: block;
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--mc-text);
  margin-bottom: 0.45rem;
}
.mc-ref-foot-card__txt {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  color: var(--mc-text-muted);
}

@media (max-width: 1199px) {
  .mc-ref-hero__meta {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 991px) {
  .mc-ref-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mc-ref-row1 {
    grid-template-columns: 1fr;
  }
  .mc-ref-row2 {
    grid-template-columns: 1fr;
  }
  .mc-ref-footer__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mc-ref-donut-wrap {
    width: 100%;
    max-width: 220px;
    margin: 0 auto;
  }
  .mc-ref-origin-layout {
    flex-direction: column;
  }
}

@media (max-width: 576px) {
  .mc-ref-kpis {
    grid-template-columns: 1fr;
  }
  .mc-ref-hero__meta {
    grid-template-columns: 1fr 1fr;
    margin-left: 0.75rem;
    margin-right: 0.75rem;
    padding: 1rem;
  }
  .mc-ref-hero__top {
    padding: 1.35rem 1rem 1rem;
  }
  .mc-ref-mesh {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mc-ref-footer__grid {
    grid-template-columns: 1fr;
  }
}

/* Estilos para tabela de pedidos */
.pedidos-container {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.pedidos-table {
  font-size: 0.9rem;
  margin-bottom: 0;
}

.pedidos-table ::v-deep th {
  background-color: #f8f9fa;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  color: #6e6b7b;
  position: sticky;
  top: 0;
  z-index: 10;
}

.pedidos-table ::v-deep td {
  vertical-align: middle;
}

.pedidos-table ::v-deep tr:hover {
  background-color: #f8f9fa;
}

/* Scrollbar personalizada */
.pedidos-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.pedidos-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.pedidos-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.pedidos-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
